<template>
  <Table>
    <template #columns>
      <th
        v-for="(column, index) in columns"
        :key="index"
        scope="col"
        class="px-2 py-3 text-left text-xs text-gray-500 uppercase tracking-wider"
        :class="{
          [column.class]: Boolean(column.class),
        }">
        <div>{{ column.text }}</div>
      </th>
    </template>
    <template #rows>
      <FileItem v-for="(document, index) in formFiles"
        :key="index"
        :docType="document.type"
        :file="document"
        :value="document"
        :editable="editableDocuments"
        :canValidate="canValidate"
        @showPicker="(value) => $emit('showPicker', value)"
        @input="(a) => onInput(document, [a.fileId, a.fileName, a.expirationDate, a.fileType])"
        @deleteFile="(fileId) => $emit('deleteFile', fileId)"
      >
      <slot></slot>
      </FileItem> 
    </template>
  </Table>
</template>

<script>

import Table from '../components/Table.vue'
import FileItem from '../components/items/FileItem.vue'

export default {
  components: {
    Table,
    FileItem,
  },
  props: {
    files: Array,
    docTypes: Array,
    editableDocuments: Boolean,
    canValidate: Boolean,
  },
  data() {
    return {
      formFiles: [],
      columns: [
        {
          name: 'file__fileType',
          text: 'Document Type'
        },
        {
          name: 'file__name',
          text: 'Name'
        },
        {
          name: 'file__thumbnail',
          text: 'Preview'
        },
        
      ],
      componentKey: 0,
    }
  },
  methods: {
    setDefault(){
      for(let docType of this.docTypes){
        let formFile = {"type": docType}
        for(let file of this.files){
          if(file.type === docType){
            formFile = {...formFile, ...file}
            break
          }
        }
        this.formFiles.push(formFile)
      }
      this.componentKey += 1
    },
    onInput(item, value) {
      this.$set(item, 'fileId', value[0])
      this.$set(item, 'fileName', value[1])
      this.$set(item, 'expirationDate', value[2])
      this.$set(item, 'fileType', value[3])
      this.$emit('input', this.formFiles)
    },
  },
  watch:{
    docTypes(){
      this.setDefault()
    },
    files() {
      this.formFiles = this.files
    },
    formFiles() {
      this.componentKey += 1
      this.$emit('input', this.formFiles)
    }
  },
  mounted() {
    if(this.canValidate){
      this.columns.push({
          name: 'file__expiration_date',
          text: 'Expiration Date'
        },
      )
    }
    this.columns.unshift({
      name: 'action',
      text: '',
      class: 'text-center w-32'
    })
  }
}
</script>
